import { sendPasswordResetEmail } from 'firebase/auth'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Button } from '../../components/ui/button.jsx'
import { auth } from '../../lib/firebase.js'

export function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [error, setError] = useState(null)
  const [submitting, setSubmitting] = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()
    setError(null)
    setSubmitting(true)
    try {
      await sendPasswordResetEmail(auth, email)
      setSent(true)
    } catch (err) {
      setError(err.message)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <main id="main-content" className="mx-auto max-w-md px-6 py-16">
      <h1 className="mb-2 text-2xl font-semibold text-[var(--color-basalt)]">Forgot password</h1>
      <p className="mb-8 text-sm text-[var(--color-schist)]">We'll email you a reset link.</p>

      {sent ? (
        <div className="space-y-4">
          <p className="text-sm text-[var(--color-basalt)]">
            If an account exists for {email}, a reset link is on its way. Check your inbox.
          </p>
          <Link
            to="/auth/login"
            className="text-sm text-[var(--color-terracotta)] underline-offset-4 hover:underline"
          >
            ← Back to sign in
          </Link>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4">
          <label className="block">
            <span className="mb-1 block text-xs font-medium uppercase tracking-wider text-[var(--color-schist)]">
              Email
            </span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              className="w-full rounded-md border border-[var(--color-sandstone)] bg-white px-3 py-2 text-sm focus:outline-none focus-visible:border-[var(--color-terracotta)]"
            />
          </label>

          {error && (
            <p className="text-sm text-[var(--color-failed)]" role="alert">
              {error}
            </p>
          )}

          <Button type="submit" disabled={submitting} variant="primary" className="w-full">
            {submitting ? 'Sending…' : 'Send reset link'}
          </Button>

          <p className="text-sm text-[var(--color-schist)]">
            <Link
              to="/auth/login"
              className="text-[var(--color-terracotta)] underline-offset-4 hover:underline"
            >
              ← Back to sign in
            </Link>
          </p>
        </form>
      )}
    </main>
  )
}
